/* eslint-disable */
import Cookies from 'js-cookie';
import https from 'https';
import { appSupportedBaseNames } from './locales';

export function getClientIp(req) {
  if (req.headers['x-forwarded-for']) {
    return req.headers['x-forwarded-for'].replace(/ /g, '').split(',').slice(-1)[0];
  }
  return req.connection.remoteAddress;
}

export function isValidAppUrl(appPath, clientIp, success, failure) {
  const options = {
    hostname: 'app.idagio.com',
    port: 443,
    path: appPath,
    method: 'HEAD',
    headers: {
      'host': 'app.idagio.com',
      'accept': '*/*',
      'user-agent': 'idagio-landing-pages', // skip geoblock
      'I-client-IP': clientIp, // trustedHeader('I-Client-IP', clientIp),
    },
  };

  try {
    const req = https.request(options, res => {
      const { statusCode } = res;
      // If the status code is 200 or redirect codes: 301, 302 or geoblocked
      // (let the app handle showing the geoblocked error page)
      if ([200, 302, 301, 406, 451].includes(statusCode)) {
        success(appPath);
      } else {
        console.log('> > > status code', appPath, statusCode); // eslint-disable-line
        failure(res.statusCode);
      }
    });

    req.on('error', e => {
      // eslint-disable-next-line no-console
      console.log('> > > Error in checking app domain; .on handler', appPath);
      // eslint-disable-next-line no-console
      console.error(e);
      failure(500);
    });

    req.end();
  } catch (e) {
    // eslint-disable-next-line no-console
    console.log('> > > Error in checking app domain', appPath);
    // eslint-disable-next-line no-console
    console.error(e);
    failure(500);
  }
}

export function getCaptchaCreds() {
  const captchaCreds = process.env.CAPTCHA_CREDENTIALS.split(':');
  return {
    captchaType: captchaCreds[0],
    captchaSiteKey: captchaCreds[1],
  };
}

function getInAppParam(urlOrigin) {
  if (urlOrigin.includes('app.idagio.com')) {
    return {
      key: 'inApp',
      value: '1',
    };
  }

  if (urlOrigin.includes('idagio.com') || urlOrigin === process.env.BASE_URL) {
    return {
      key: 'ctc',
      value: 'inapp-webview',
    };
  }

  return null;
}

export function getUrlWithStickyParams(uri, basename) {
  const currentBasename = basename || '';
  const url = new URL(uri, process.env.BASE_URL);
  // sticks locale. for example /magazine to /{locale}/magazine
  if (url.origin === process.env.BASE_URL || url.origin === process.env.APP_DOMAIN) {
    // for app links, only keep the locale if the app supports it; otherwise default to english locale
    const targetBasename =
      url.origin === process.env.APP_DOMAIN && !appSupportedBaseNames.includes(currentBasename)
        ? ''
        : currentBasename;
    // if the pathname provided was /{locale}/magazine, remove locale first to prevent duplicated locales
    url.pathname = url.pathname.replace(`/${currentBasename}/`, '/');
    // now sticks the locale in front of the path
    url.pathname = targetBasename + url.pathname;
  }

  // sticks inApp param if in app
  const isInApp = Cookies.get('ctc') === 'inapp-webview';
  if (isInApp) {
    const inAppParam = getInAppParam(url.origin);
    if (inAppParam) {
      url.searchParams.set(inAppParam.key, inAppParam.value);
    }
  }

  // sticks fromId if provided uri contains `f=true`
  const currentPageUrl = new URL(window.location.href);
  const fromId = currentPageUrl.searchParams.get('f');

  if (fromId && url.searchParams.get('f')) {
    url.searchParams.set('f', fromId);
  }

  // sticks all other search params
  const currentParams = new URLSearchParams(window.location.search);
  currentParams.forEach((value, key) => {
    if (key !== 'ctc' && key !== 'f') {
      url.searchParams.set(key, value);
    }
  });
  return url.toString();
}



// WEBPACK FOOTER //
// /tmp/build_83f21ab6/src/util.js